var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoach(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 188.1 89.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:none;stroke:#2772af;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 23.36,
    cy: 48,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M142.66,46.9h0c3.1,1,3.1,4,0,5h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M98.96,23.5c4.5-5,8.8-8.3,14-12.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M107.56,26.3c2.6-2.9,3.9-3.9,7-6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M129.36,76.4c-4.2-2.7-8.1-5.8-11.8-9.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M90.26,80.5c-2.1-1.5-3.5-2.9-3.2-5.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M131.36,67.7c-2.1-1.3-4-2.9-5.8-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M36.06,56.7c.7,4.9-1.3,8.8-5.9,11.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M40.06,32.4c7.6,8.3,8.6,19.7,2.5,27.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 156.86,
    y1: 48,
    x2: 171.66,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 161.16,
    y1: 36.1,
    x2: 178.86,
    y2: 36.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 158.46,
    y1: 59.1,
    x2: 180.56,
    y2: 59.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M151.96,40.9c5.5,4.3,5.1,12.1,1.7,16.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M89.36,22.4c8-10,12.8-15.1,25.6-20.4-1.6,3.7-1.9,7.1-1.9,7.9-.2,3.9,1.6,13.3,5.8,17.4l-2.1,2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M107.26,70.4c2.7,2.3,5.4,4.6,8,6.8,4.1,3.5,7.8,7.6,13.3,8.8,.6,.1,1.3,.2,2.7,.1,0,0-1.1-4.2-1.3-5.3-.9-4.9-.7-10.7,3.1-14.3,1.2-1.2,2.7-2.8,3.7-3.9,.6-.7,.3-1.8-.5-2.1-1.6-.6-3.7-1.4-3.7-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M76.06,75.8c3.2,3.9,7.4,7.6,12.2,9.2,3.2,1.1,6.5,1.8,9.8,2.3,0,0-1.2-.9-2.1-2.8-1-2.2-1-4.7-.2-7l1.5-4.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M62.66,75c2,.1,4,.3,6.3,.4,6.6,.4,15.4-.5,22-1.2,10.1-1.1,13.9-2.9,22.7-6.2,8-3,14.5-7.4,21.4-9.9,1.8-.6,3.7-1.2,5.5-1.4,1.6-.2,3.4-.2,5-.2,10.4,.2,19.1,5.8,28.7,9,2.3,.8,7.3,2.5,10.1,2.8,1.5,.1,2.2-1.8,1.4-3.3-1.9-3.3-13.2-13.9-14.2-16.9-1.1-3.3,13.5-18.9,13.9-19.5,.9-1.5-.4-2-1.9-1.8-2.5,.2-7.2,1.5-9.3,2.4-7.4,3.2-12,5.8-18,9.3-5.8,3.4-12.8,4.3-18.8,1.5-20.1-9.3-35-16.5-51.4-16.9-10-.2-20.9,1.1-30.6,3.8-9.2,2.6-20.6,6.6-23,7.6-3.3,1.3-20.5,7.6-23.7,9.3-3.9,2.1-8.2,5.1-6.3,8.7,2.1,3.9,6.8,6.3,10.4,8.4,2.8,1.6,8.5,4.5,11.6,5.7,6.7,2.5,12.2,4.3,17.6,5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M48.46,66.9s10.6-2.9,16.7-3.1c0,0-.3,6.7,7,11.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M62.66,75c-4.1-.4-16.9-1.7-24.5-3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M56.96,70.1c1.5,.3,3,.4,4.5,.1,1.5-.2,2.9-.7,4.4-1.1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoach);
export default __webpack_public_path__ + "static/media/Roach.de46f145fa4691964c34dd3c83c4014e.svg";
export { ForwardRef as ReactComponent };